export const dataModel = {
  url: "/api/publicationslisting",
  initialResults: 15, // number of results on first page
  perPage: 15, // number of additional results when load more is clicked
  loadMore: true,
  loadMoreText: "More Faculty",
  includeSearchBar: true, // hide search bar if false
  searchPlaceholder: "Search Faculty", // placeholder on search bar
  showFacetsLabel: "Filters",
  clearAllLabel: "Reset",
  facetKeys: ["facultyType, departments"],
};

export const dataQuery = {
  pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
  listingId: "dfa28f3c-f7b7-45bd-b789-91cd2a2547cd",
};

export const mockApiResponse = {
  request: {
    pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
    page: 1,
    perPage: 5,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {},
  },
  totalResults: 8436,
  results: [
    {
      key: "{DEC91732-1A96-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Francesca Cornelli",
      title:
        "Donald P. Jacobs Scholar; Assistant Professor of Management and Organizations",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{C7803B02-42BA-11EC-8551-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",
        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Janice Eberly",
      title:
        "Senior Associate Dean, Strategy and Academics; Professor of Finance",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{46EE403B-1689-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Bernard (Bernie) Banks",
      title:
        "Associate Dean for Leadership Development and Inclusion; Clinical Professor of Management",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{DEC91732-1A96-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Francesca Cornelli",
      title:
        "Donald P. Jacobs Scholar; Assistant Professor of Management and Organizations",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{C7803B02-42BA-11EC-8551-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Janice Eberly",
      title:
        "Senior Associate Dean, Strategy and Academics; Professor of Finance",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{46EE403B-1689-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Bernard (Bernie) Banks",
      title:
        "Associate Dean for Leadership Development and Inclusion; Clinical Professor of Management",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{DEC91732-1A96-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Francesca Cornelli",
      title:
        "Donald P. Jacobs Scholar; Assistant Professor of Management and Organizations",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{C7803B02-42BA-11EC-8551-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Janice Eberly",
      title:
        "Senior Associate Dean, Strategy and Academics; Professor of Finance",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{46EE403B-1689-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Bernard (Bernie) Banks",
      title:
        "Associate Dean for Leadership Development and Inclusion; Clinical Professor of Management",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{DEC91732-1A96-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Francesca Cornelli",
      title:
        "Donald P. Jacobs Scholar; Assistant Professor of Management and Organizations",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{C7803B02-42BA-11EC-8551-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",
        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Janice Eberly",
      title:
        "Senior Associate Dean, Strategy and Academics; Professor of Finance",
      url: "/faculty/directory/brady_william",
    },
    {
      key: "{46EE403B-1689-11E8-91BE-0242AC160003}",
      images: {
        desktop1X: "https://via.placeholder.com/342x285",
        desktop2X: "https://via.placeholder.com/684x570",

        mobile2X: "https://via.placeholder.com/1026x855",
      },
      name: "Bernard (Bernie) Banks",
      title:
        "Associate Dean for Leadership Development and Inclusion; Clinical Professor of Management",
      url: "/faculty/directory/brady_william",
    },
  ],
  facets: [
    {
      id: "facultyType",
      label: "Tenure-Line & Clinical",
      values: [
        {
          id: "Tenure-line",
          name: "Tenure-line",
          count: 1017,
          selected: false,
          childValues: [],
        },
        {
          id: "Clinical",
          name: "Clinical",
          count: 615,
          selected: false,
          childValues: [],
        },
        {
          id: "Emeritus",
          name: "Emeritus",
          count: 979,
          selected: false,
          childValues: [],
        },
        {
          id: "Other",
          name: "Other",
          count: 979,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
    {
      id: "departments",
      label: "All Departments & Centers",
      values: [
        {
          id: "Accounting Information & Management",
          name: "Accounting Information & Management",
          count: 690,
          selected: false,
          childValues: [],
        },
        {
          id: "Finance",
          name: "Finance",
          count: 1252,
          selected: false,
          childValues: [],
        },
        {
          id: "Management & Organizations",
          name: "Management & Organizations",
          count: 1204,
          selected: false,
          childValues: [],
        },
        {
          id: "Managerial Economics & Decision Sciences",
          name: "Managerial Economics & Decision Sciences",
          count: 776,
          selected: false,
          childValues: [],
        },
        {
          id: "Marketing",
          name: "Marketing",
          count: 330,
          selected: false,
          childValues: [],
        },
        {
          id: "Operations",
          name: "Operations",
          count: 300,
          selected: false,
          childValues: [],
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 769,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
  ],
};
